/* eslint-disable react/no-array-index-key */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { memo, useCallback, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ICategoriesProps, IClassificationProps } from 'interface/inspection/InspectionInfo';
import SelectMenuChange from './SelectMenuChange';

interface CategoryListProps {
  categories: ICategoriesProps[];
}

function PlayerRightCmn({ categories }: CategoryListProps): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [openId, setOpenId] = useState('');
  const handleMenuStatus = useCallback((_open: boolean, _item: IClassificationProps) => {
    if (_open && _item.id) {
      setOpenId(_item.id);
    }
    if (!_open) {
      setOpenId('');
    }
  }, []);
  return (
    <Box sx={{ p: 1 }}>
      {isMobile && (
        <Box
          sx={{
            width: 30,
            height: 6,
            backgroundColor: 'rgb(224, 224, 224)',
            borderRadius: '3px',
            position: 'relative',
            top: '-10px',
            left: 'calc(50% - 15px)',
          }}
        />
      )}
      <Typography sx={{ mb: isMobile ? 1 : 2, fontSize: isMobile ? '20px' : '34px', fontWeight: 700 }}>
        분류 기록
      </Typography>
      {categories.map(category => (
        <Accordion key={category.id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  bgcolor: category.color,
                  mr: 2,
                }}
              />
              <Typography>{category.name}</Typography>
              <Typography
                sx={{
                  ml: 'auto',
                  color: 'text.secondary',
                  mr: 2,
                }}
              >
                {category.count}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              p: '7px 0px',
              maxHeight: 140,
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f0f0f0',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#3154ea',
                borderRadius: '10px',
              },
            }}
          >
            <List disablePadding>
              {category.items.map((item, index) => (
                <ListItem
                  key={index}
                  divider={false}
                  secondaryAction={<SelectMenuChange item={item} handleMenuStatus={handleMenuStatus} />}
                  sx={{
                    py: '4px',
                    cursor: 'pointer',
                    '& .MuiListItemText-primary': {
                      width: 'calc(100% - 25px)',
                      whiteSpace: item.id === openId ? 'wrap' : 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                  }}
                >
                  <ListItemText primary={item.content} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}

export default memo(PlayerRightCmn);
